import {
    createContext,
    useContext,
    useState,
    ReactNode,
    SetStateAction,
    Dispatch,
  } from "react";
  
  interface Price{
    priceForOtherAfricans: number;
    priceInDollars: number;
    priceInEuros: number;
    priceInNaira: number;
  }
  interface Tutor{
    Image:string;
    Name:string;
    Note:string;
    Rating:number;
    Title:string;
  }
  type Course = {
    Category: string;
    Cohort: string;
    CourseDescription: string[];
    Tutor: Tutor;
    CourseName: string;
    CourseImage: string;
    CourseOutline: string[];
    CourseDelivery: string[];
    TargetAudience: string[];
    Whatyouwilllearn: string[];
    Packages: string[];
    Duration: string;
    Price:Price;
    ProgramType: string;
    disablebtn: boolean;
    discount: number;
    id: string;
    isArchive: boolean;
    noCode: boolean;
    noTutor: boolean;
    showDiscount: boolean;
    ShortDescription: string;
  }
  
  interface CourseContextType {
    courses: Course[] | null;
    setCoursesContext: Dispatch<SetStateAction<Course[] | null>>;
  }
  
  const CourseContext = createContext<CourseContextType | null>(null);
  
  interface CourseProviderProps {
    children: ReactNode;
  }
  
  
  export const CourseProvider: React.FC<CourseProviderProps> = ({ children }) => {
    const [courses, setCoursesContext] = useState<Course[] | null>(null);
   
  
    return (
      <CourseContext.Provider value={{ courses, setCoursesContext }}>
        {children}
      </CourseContext.Provider>
    );
  };
  
  export const useCourses = () => {
    const context = useContext(CourseContext);
    if (!context) {
      throw new Error("useCourses must be used within a CourseProvider");
    }
    return context;
  };
  
  
  
  